import { render } from "./DocumentsTable.vue?vue&type=template&id=56577233&scoped=true"
import script from "./DocumentsTable.vue?vue&type=script&lang=js"
export * from "./DocumentsTable.vue?vue&type=script&lang=js"

import "./DocumentsTable.vue?vue&type=style&index=0&id=56577233&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56577233"]])

export default __exports__